<div class="auth-wrapper auth-v2">
	<div class="auth-inner row m-0 pb-0" style="overflow-x: hidden;">
		<div class="global-rllipse d-block d-lg-none"></div>

		<!-- Left Section-->
		<div class="d-flex col-lg-5 align-items-center auth-bg px-2 p-lg-5 reset-password-form-section">
			<div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
				<div class="w-100 text-center mb-2">
					<img src="assets/images/logo/logo-white.png" alt="logo" height="60" />
				</div>
				<div class="reset-password-form-header">
					<h1>{{ 'RESET_PASSWORD.TITLE' | translate }}</h1>
					<p>{{ 'RESET_PASSWORD.TEXT' | translate }}</p>
				</div>
				<div class="middle-container">
					<article class="reset-password-requirement mb-1" style="padding-left: 1rem;">
						<div class="row password-requirement">
							<div class="col-6 item">
								<div [ngClass]="{'requirement-valid': minlengthValid}">
									{{ 'RESET_PASSWORD.AT_LEAST_8_CHARS' | translate }}
								</div>
							</div>
							<div class="col-6 item">
								<div [ngClass]="{'requirement-valid': capitalValid}">
									{{ 'RESET_PASSWORD.ONE_UPPERCASE' | translate }}
								</div>
							</div>
							<div class="col-6 item">
								<div [ngClass]="{'requirement-valid': digitValid}">
									{{ 'RESET_PASSWORD.ONE_NUMBER' | translate }}
								</div>
							</div>
							<div class="col-6 item">
								<div [ngClass]="{'requirement-valid': specialValid}">
									{{ 'RESET_PASSWORD.ONE_SPECIAL' | translate }}
								</div>
							</div>
						</div>
					</article>
				</div>
				<div class="middle-container">
					<form class="auth-reset-password-form mt-2" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
						<password-input [id]="'reset-password-new'" [label]="'RESET_PASSWORD.NEW_PASSWORD' | translate"
							formControlName="newPassword" [placeholder]="'············'" [submitted]="submitted"
							[displayErrorMessage]="false"></password-input>
						<password-input [id]="'reset-password-confirm'" [label]="'RESET_PASSWORD.CONFIRM_PASSWORD' | translate"
							formControlName="confirmPassword" [placeholder]="'············'" [submitted]="submitted"
							[displayErrorMessage]="true"></password-input>
						<terms-of-use-input [id]="'reset-password-terms-of-use'" [prefix]="'RESET_PASSWORD.TERMS_PREFIX' | translate"
							[label]="'RESET_PASSWORD.TERMS_LABEL' | translate" formControlName="termOfUse" [submitted]="submitted"
							(action)="displayTermsOfUse($event)"></terms-of-use-input>
						<button type="submit" [disabled]="loading" class="btn btn-gradient-primary btn-block"
							rippleEffect>
							<span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>{{ 'RESET_PASSWORD.SET_NEW_PASSWORD' | translate }}
						</button>
					</form>
				</div>
			</div>
		</div>

		<!-- Right Section -->
		<div class="d-none d-lg-flex col-lg-7 reset-password-illustration-section">
			<div class="w-100 reset-password-illustration-image">
				<div class="rllipse"></div>
				<img src="assets/images/pages/reset-password-v2-dark.svg" alt="Reset password" />
			</div>
		</div>
	</div>
</div>
